import * as React from 'react';

const PageContextMapContext = React.createContext({});

export const PageContextMapProvider = PageContextMapContext.Provider;

export const usePageContextMap = () => {
    const context = React.useContext(PageContextMapContext);
    return context;
}